import { useQuery } from "@apollo/client";

import DtsReactTable from "../../../reuseableComponents/dtsReactTable/DtsReactTable";
import { GET_CHEMICAL_RULE_VIOLATIONS } from "../../../../queries/archiveQrys/IpsReportQueries";
import { convertTimeStampToDate } from "../../../../utilities/commonFunctions/timeConversionFunctions";
import SkeletonLoader from "../../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../../reuseableComponents/ErrorHandler";

const ChemicalRuleViolationTable = ({ systemId }) => {
  const columns = [
    {
      Header: "Facility",
      accessor: "facilityCode",
      width: 80
    },
    {
      Header: "Violation No.",
      accessor: "violationNumber"
    },
    {
      Header: "Period",
      accessor: (d) => {
        return convertTimeStampToDate(d.violationBeginDate) + " - " + convertTimeStampToDate(d.violationEndDate);
      }
    },
    {
      Header: "Code",
      accessor: "typeCode",
      width: 80
    },
    {
      Header: "Violation Type",
      accessor: "violationType"
    },
    {
      Header: "Analyte Group",
      accessor: "analyteGroup"
    },
    {
      Header: "Determined",
      accessor: (d) => {
        return convertTimeStampToDate(d.determinationDate);
      }
    },
    {
      Header: "Seasonality",
      accessor: "seasonality",
      width: 115
    },
    {
      Header: "Points Effective",
      accessor: "pointsEffective"
    }
  ];

  const { loading, error, data } = useQuery(GET_CHEMICAL_RULE_VIOLATIONS, { variables: { systemId } });
  let totalPoints = 0;

  if (loading) {
    return <SkeletonLoader width='100%'/>;
  } else if (error) {
    return <ErrorHandler error={error} />
  }else {
    let chemArray = data.getChemicalRuleViolationsBySystemId;
    chemArray.forEach((violation) => {
      if (violation.pointsEffective > 0) {
        totalPoints = totalPoints + violation.pointsEffective;
      }
    });
  }

  return (
    <>
      {data.getChemicalRuleViolationsBySystemId.length > 0 ? (
        <>
          <DtsReactTable data={data.getChemicalRuleViolationsBySystemId} columns={columns} headerColor="ddw" cypressid="ChemRuleVioTbl"/>
          <h5>Total Points: {totalPoints}</h5>
        </>
      ) : (
        <span>
          <em>No chemical rule violations were found in the database.</em>
        </span>
      )}
    </>
  );
};

export default ChemicalRuleViolationTable;
